import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Avatar,
  CircularProgress,
  Grid,
  Divider,
  Button,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import { useLocation, useNavigate } from "react-router-dom";
import { UrlConstant } from "../../../commom/UrlConstant";
import Axios from "../../../config/axios";
import moment from "moment";
import { formatTimestampToUserTimezone, getPaymentDisplayDetails } from "../../../utils/utils";
import { calculateCryptoChange } from "../../../utils/utils";
import { endLoading, startLoading } from '../../../Redux/loadingSlice';
import Repayment from "../Cards/repayment";
import Successpopup from '../SharedComponent/Successpopup';
import CloseIcon from "@mui/icons-material/Close";
import BuySell from "../Cards/BuySell";
import usePaymentMethods from "../../../hooks/usePaymentMethods";
import BoosterLoanPaymentDialog from "../Dialogs/BoosterLoanPaymentDialog";
import { extractQuoteWithFallback } from "../../../helpers/cryptoQuoteHelper";
import { usePriceFormatter } from "../../../hooks";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { formatPercentage } from "../../../utils/formatting";

const MemoizedBuySell = React.memo(BuySell);

const STATUS_CONFIG: Record<
  string,
  { label: string; color: string }
> = {
  RETRY: { label: "RETRY", color: "#4A7AF2" },
  FAILED: { label: "FAILED", color: "#FF0000" },
  PAID: { label: "PAID", color: "#4EDF6D" },
  DUE: { label: "UPCOMING", color: "#4A7AF2" },
  UNDUE: { label: "REMAINING", color: "#F2674A" },
  OVERDUE: { label: "OVERDUE", color: "#FF0000" },
  INPROGRESS: { label: "IN PROGRESS", color: "white" },
};

function BoosterLoanDetails() {
  const [showPopup, setShowPopup] = useState(false);
  const [heading, setHeading] = useState('');
  const [Success, setSuccess] = useState(false);
  const [msg, setMsg] = useState('');
  const [buySellRefreshKey, setBuySellRefreshKey] = useState(0);

  const closePopup = () => {
    setShowPopup(false);
    // Refresh BuySell component after popup closes if payment was processed
    if (heading === 'Success' || heading === 'Error') {
      // Refresh crypto details to update BuySell component
      if (stock) {
        fetchCryptoDetails(stock);
      }
      // Force re-render by updating key
      setBuySellRefreshKey(prev => prev + 1);
    }
  };
  const formatter = usePriceFormatter()
  const [payDialogOpen, setPayDialogOpen] = useState(false);
  const location = useLocation();
  const navigation = useNavigate();
  const { paymentMethods, fetchAllPaymentMethods } = usePaymentMethods();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState<any>(false);
  const [boosterLoanDetails, setBoosterLoanDetails] = React.useState<any>();
  const [openPopup, setOpenPopup] = useState(false);
  const [showPaymentMethodDialog, setShowPaymentMethodDialog] = useState(false)
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState<string | null>(null)
  const [cryptoDetails, setCryptoDetails] = useState<any>(null);
  const currencyInfo = useAppSelector((state) => state.currency);
  const currencyKey = currencyInfo.effectiveCurrency || 'USD';
  const quote = extractQuoteWithFallback(cryptoDetails as any, currencyKey);
  const memoizedStockDetail = useMemo(() => {
    if (!cryptoDetails) return null;
    return {
      ...cryptoDetails,
      displayName: cryptoDetails?.name,
    };
  }, [cryptoDetails]);

  const memoizedTickerData = useMemo(() => {
    const price = Number(quote?.price ?? 0);
    const percentChange = Number(quote?.percent_change_24h ?? 0);
    const denominator = 1 + percentChange / 100;
    const previousClose = denominator !== 0 ? price / denominator : 0;
    const diffAmount = price - previousClose;

    return {
      lastPrice: price,
      previousClose,
      diffAmount,
      percentage: percentChange,
    };
  }, [cryptoDetails]);
  const [isPollingPaymentStatus, setIsPollingPaymentStatus] = useState(false);
  const [trackedInstallmentIds, setTrackedInstallmentIds] = useState<string[]>([]);
  const [trackedInstallmentNos, setTrackedInstallmentNos] = useState<number[]>([]);
  const [trackedInitialStatuses, setTrackedInitialStatuses] = useState<Record<string, string>>({});
  const pollingIntervalRef = React.useRef<NodeJS.Timeout | null>(null);
  const pollingStartTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const normalizeStatus = (status: any): string => {
    if (!status) return '';
    return status
      .toString()
      .replace(/[\s_\-]/g, '')
      .toUpperCase();
  };

  const stock = location.state?.symbol;
  const loan_id = location.state?.loan_id;
  const getBoosterInstallments = async (silent: boolean = false) => {
    if (!silent) {
      setLoading(true)
    }
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.GetBoosterLoanInstallment.replace("{0}", loan_id)
      );
      const resData = response.data;
      if (resData.status === true) {
        setBoosterLoanDetails(resData.data);
        return resData.data;
      }
      return null;
    } catch (error: any) {
      console.error("ERRR : ", error);
      return null;
    } finally {
      if (!silent) {
        setLoading(false)
      }
    }
  };

  const fetchCryptoDetails = async (symbol: string) => {
    if (!symbol) return;
    try {
      const response = await Axios.get(UrlConstant.Crypto.GetCryptoSearch.replace("{0}", symbol));
      const data = response.data?.data || [];
      const crypto = data.find((item: any) => item.symbol?.toUpperCase() === symbol?.toUpperCase());
      setCryptoDetails(crypto || null);
    } catch (error) {
      setCryptoDetails(null);
      console.error('Error fetching crypto details:', error);
    }
  };

  useEffect(() => {
    if (stock) fetchCryptoDetails(stock);
  }, [stock]);


  const handleOpenPopup = (row: any) => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const updatePaymentMethod = async (
    loanId: string,
    paymentAccountId: string,
    type: string
  ) => {
    if (!loanId || !paymentAccountId || !type) {
      console.error('Invalid payload');
      return;
    }

    setLoading(true);
    dispatch(startLoading());

    try {
      const response = await Axios.post(
        UrlConstant.BoosterLoan.UpdatePaymentMethod,
        null,
        {
          params: {
            loanId,
            customerPaymentProfileId: paymentAccountId,
            paymentMethodType: type,
          }
        }
      );

      if (response.data?.status) {
        setOpenPopup(false);
      }
    } catch (error: any) {
      console.error('Error updating payment method:', error);
    } finally {
      setLoading(false);
      dispatch(endLoading());
      getBoosterInstallments();
    }
  };

  useEffect(() => {
    if (boosterLoanDetails?.loanDetail?.payment_method_id) {
      setSelectedPaymentMethodId(boosterLoanDetails.loanDetail.payment_method_id);
    }
  }, [boosterLoanDetails]);

  const handleChangeMethod = (method: any) => {
    if (!boosterLoanDetails?.loanDetail?.id) {
      console.error('Missing loanId');
      return;
    }
    const { id, type } = method;
    if (!id || !type) {
      console.error('Missing payment method data');
      return;
    }

    updatePaymentMethod(
      boosterLoanDetails.loanDetail.id,
      id,
      type
    );
  };


  const getLogoUrl = (symbol: string) => {
    if (!symbol) {
      return '';
    }
    return `https://logos-api.extend.apexclearing.com/logos/${symbol.toLowerCase().trim()}.png?api_key=4RJeGywzAE&api_secret=isUE1ZzPNi5IzXbs9Qg0S01eaFUcxX09c4U88R9JBiJgJ6WxXHrXz3VtEima`;
  };

  const selectedMethodDetails = getPaymentDisplayDetails(
    boosterLoanDetails?.loanDetail?.payment_method_id,
    paymentMethods,
    28
  );

  const stopPolling = () => {
    if (pollingStartTimeoutRef.current) {
      clearTimeout(pollingStartTimeoutRef.current);
      pollingStartTimeoutRef.current = null;
    }
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
  };

  // Polling logic for payment status
  const startPaymentStatusPolling = (
    installmentIds: string[],
    installmentNos?: number[],
    successMessage: string = 'Payment processed successfully!'
  ) => {
    if (installmentIds.length === 0) {
      setHeading('Success');
      setSuccess(true);
      setMsg(successMessage);
      setShowPopup(true);
      return;
    }

    // Prevent multiple polling sessions - if already polling, don't start another
    if (isPollingPaymentStatus || pollingIntervalRef.current) {
      console.warn('Polling already in progress, skipping new polling session');
      return;
    }

    // Ensure any existing polling is stopped
    stopPolling();

    setTrackedInstallmentIds(installmentIds);
    if (installmentNos && installmentNos.length > 0) {
      setTrackedInstallmentNos(installmentNos);
    } else {
      setTrackedInstallmentNos([]);
    }

    const initialStatusMap: Record<string, string> = {};
    boosterLoanDetails?.installments?.forEach((inst: any) => {
      if (installmentIds.includes(inst.id)) {
        initialStatusMap[inst.id] = normalizeStatus(inst.status);
      }
    });
    setTrackedInitialStatuses(initialStatusMap);
    setIsPollingPaymentStatus(true);
    setPayDialogOpen(false); // Close payment dialog
    // Loader will be shown via isPollingPaymentStatus state

    let hasSeenInProgress = false;
    let pollCount = 0;
    let noStatusChangeCount = 0;
    const maxPolls = 60; // Maximum ~2 minutes
    const maxNoStatusChangePolls = 10; // If status doesn't change after 10 polls (20 seconds), show failure
    const trackedNos = installmentNos || []; // Capture installmentNos in closure

    const startPolling = () => {
      // Double-check we're not already polling
      if (pollingIntervalRef.current) {
        return;
      }

      pollingIntervalRef.current = setInterval(async () => {
        // Safety check: if polling interval was cleared, exit immediately
        if (!pollingIntervalRef.current) {
          return;
        }

        pollCount++;

        // Safety: stop polling after max attempts
        if (pollCount > maxPolls) {
          stopPolling();
          setIsPollingPaymentStatus(false);
          setTrackedInstallmentIds([]);
          setTrackedInstallmentNos([]);
          setTrackedInitialStatuses({});
          setHeading('Error');
          setSuccess(false);
          setMsg('Payment status check timed out. Please refresh the page.');
          setShowPopup(true);
          await getBoosterInstallments(true); // Silent refresh
          return;
        }

        const data = await getBoosterInstallments(true); // Silent fetch
        if (!data?.installments) {
          // If no data and we've been polling for a while, stop
          if (pollCount > 10) {
            stopPolling();
            setIsPollingPaymentStatus(false);
            setTrackedInstallmentIds([]);
            setTrackedInstallmentNos([]);
            setTrackedInitialStatuses({});
          }
          return;
        }

        // If tracking by installment numbers, filter by those numbers
        let trackedInstallments;
        if (trackedNos.length > 0) {
          trackedInstallments = data.installments.filter((inst: any) =>
            trackedNos.includes(inst.installment_no)
          );
        } else {
          trackedInstallments = data.installments.filter((inst: any) =>
            installmentIds.includes(inst.id)
          );
        }

        if (trackedInstallments.length === 0) {
          // If tracked installments not found after several polls, stop
          if (pollCount > 10) {
            stopPolling();
            setIsPollingPaymentStatus(false);
            setTrackedInstallmentIds([]);
            setTrackedInstallmentNos([]);
            setTrackedInitialStatuses({});
          }
          return;
        }

        const statuses = trackedInstallments.map((inst: any) => normalizeStatus(inst.status));
        const hasInProgress = statuses.includes('INPROGRESS');

        // Once we see InProgress, mark it and continue polling
        if (hasInProgress) {
          hasSeenInProgress = true;
          noStatusChangeCount = 0; // Reset counter when we see progress
        }

        const allPaid = statuses.every((status) => status === 'PAID');
        const allProcessed = statuses.every((status) => status !== 'INPROGRESS');
        const hasFailureStatus = statuses.some((status) =>
          ['FAILED', 'ERROR', 'DECLINED', 'CANCELLED'].includes(status)
        );
        const statusesChanged = trackedInstallments.some((inst: any) => {
          const currentStatus = normalizeStatus(inst.status);
          const hasInitialStatus = Object.prototype.hasOwnProperty.call(trackedInitialStatuses, inst.id);
          const initialStatus = hasInitialStatus ? trackedInitialStatuses[inst.id] : currentStatus;
          return currentStatus !== initialStatus;
        });

        // If tracking by installment numbers and status hasn't changed, increment counter
        if (trackedNos.length > 0 && !statusesChanged && !hasInProgress) {
          noStatusChangeCount++;

          // If status hasn't changed after max attempts, show failure
          if (noStatusChangeCount >= maxNoStatusChangePolls) {
            stopPolling();
            setIsPollingPaymentStatus(false);
            setTrackedInstallmentIds([]);
            setTrackedInstallmentNos([]);
            setTrackedInitialStatuses({});
            setHeading('Error');
            setSuccess(false);
            setMsg('Your payment failed due to some reasons');
            setShowPopup(true);
            await getBoosterInstallments(true); // Silent refresh
            return;
          }
        } else if (statusesChanged || hasInProgress) {
          // Reset counter if status changed or we see progress
          noStatusChangeCount = 0;
        }

        // If all are paid, stop polling and show success
        if (allPaid) {
          stopPolling();
          setIsPollingPaymentStatus(false);
          setTrackedInstallmentIds([]);
          setTrackedInstallmentNos([]);
          setTrackedInitialStatuses({});
          setHeading('Success');
          setSuccess(true);
          setMsg(successMessage);
          setShowPopup(true);
          await getBoosterInstallments(true); // Silent refresh
          return;
        }

        // If we've seen InProgress and status changed away from InProgress but not all paid, it failed
        if (hasSeenInProgress && allProcessed && !allPaid) {
          stopPolling();
          setIsPollingPaymentStatus(false);
          setTrackedInstallmentIds([]);
          setTrackedInstallmentNos([]);
          setTrackedInitialStatuses({});
          setHeading('Error');
          setSuccess(false);
          setMsg('Your installment payment failed');
          setShowPopup(true);
          await getBoosterInstallments(true); // Silent refresh
          return;
        }

        // If failure status detected, stop immediately
        if (hasFailureStatus) {
          stopPolling();
          setIsPollingPaymentStatus(false);
          setTrackedInstallmentIds([]);
          setTrackedInstallmentNos([]);
          setTrackedInitialStatuses({});
          setHeading('Error');
          setSuccess(false);
          setMsg('Your installment payment failed');
          setShowPopup(true);
          await getBoosterInstallments(true); // Silent refresh
          return;
        }

        // If statuses changed but we never saw InProgress and not all paid, it might have failed
        if (!hasSeenInProgress && allProcessed && statusesChanged && !allPaid) {
          stopPolling();
          setIsPollingPaymentStatus(false);
          setTrackedInstallmentIds([]);
          setTrackedInstallmentNos([]);
          setTrackedInitialStatuses({});
          setHeading('Error');
          setSuccess(false);
          setMsg('Your installment payment failed');
          setShowPopup(true);
          await getBoosterInstallments(true); // Silent refresh
          return;
        }

        // If nothing has changed yet and we haven't seen InProgress after several attempts, stop polling
        // (Only if not tracking by installment numbers - installment number tracking has its own logic above)
        if (trackedNos.length === 0) {
          if (!hasSeenInProgress && !hasInProgress && !statusesChanged && pollCount >= 5) {
            stopPolling();
            setIsPollingPaymentStatus(false);
            setTrackedInstallmentIds([]);
            setTrackedInstallmentNos([]);
            setTrackedInitialStatuses({});
            return;
          }
        }

        // Continue polling - loader stays constant until status changes
      }, 1000); // Poll every 1 second
    };

    // Start polling immediately (no delay)
    startPolling();
  };

  // Cleanup polling on unmount
  useEffect(() => {
    return () => {
      stopPolling();
    };
  }, []);

  useEffect(() => {
    if (loan_id) {
      getBoosterInstallments()
    }
  }, [loan_id])

  const remainingPayableInstallments =
    (boosterLoanDetails?.remaining_installment || 0) -
    (boosterLoanDetails?.installments?.filter(i => i.status === 'InProgress')?.length || 0);

  return (
    <Container maxWidth={false} className="bg-color" style={{ minHeight: '100vh', paddingTop: '30px' }}>
      {(loading || isPollingPaymentStatus) && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bgcolor="rgba(0, 0, 0, 0.5)"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
          style={{
            backdropFilter: "blur(5px)",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" />
          {isPollingPaymentStatus && (
            <Typography variant="body2" sx={{ color: 'white', mt: 2 }}>
              Processing payment status...
            </Typography>
          )}
        </Box>
      )}

      <Typography className="text-secondary">
        <span
          onClick={() => navigation('/boosterLoan')}
          style={{
            color: "#4A7AF2",
            cursor: "pointer",
            display: "inline-block",
            padding: "2px 4px",
            margin: "-2px -4px", // expand hit area without shifting layout
            borderRadius: "4px",
            position: "relative",
            zIndex: 1,
            pointerEvents: "auto",
          }}
        >
          Booster Loan
        </span>
        <span> / {stock}</span>
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <Card className="w-100" style={{ backgroundColor: "transparent", border: '0px', boxShadow: 'none' }}>
            <CardContent className="text-white">
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar
                    src={cryptoDetails?.logo ? cryptoDetails?.logo : getLogoUrl(cryptoDetails?.symbol)}
                    alt={cryptoDetails?.symbol || stock}
                    sx={{ width: 64, height: 64 }}
                  />
                  <Box>
                    <Typography variant="h5" gutterBottom>{cryptoDetails?.name}</Typography>
                    <Typography>
                      {cryptoDetails?.symbol || boosterLoanDetails?.loanDetail?.symbol}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="h4" fontSize='32px'>{formatter.balance(boosterLoanDetails?.loanDetail?.total_amount).display}</Typography>
              </Box>

              <Box mt={4}>
                <LinearProgress
                  variant="determinate"
                  sx={{
                    height: '10px', borderRadius: '20px', bgcolor: "#FFFFFF1A",
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#4A7AF2',
                    },
                  }}
                  value={
                    (boosterLoanDetails?.loanDetail?.paid_amount /
                      (boosterLoanDetails?.loanDetail?.paid_amount + boosterLoanDetails?.loanDetail?.remaining_amount)) *
                    100
                  }
                />
                <Box className="text-white" display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                  <Box mt='20px'>
                    <Typography variant="subtitle2">
                      {boosterLoanDetails?.paid_installment} Paid
                    </Typography>
                    <Typography variant="h6">
                      {formatter.balance(boosterLoanDetails?.loanDetail?.paid_amount).display}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2">
                      {boosterLoanDetails?.remaining_installment} Remaining
                    </Typography>
                    <Typography variant="h6">
                      {formatter.balance(boosterLoanDetails?.loanDetail?.remaining_amount_now).display}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Box className="text-white" display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
            <Typography variant="h6">Payment Schedule</Typography>
            {remainingPayableInstallments > 0 && (
              <Button
                variant="contained"
                className="btn-primary"
                sx={{ borderRadius: '20px', textTransform: 'none', padding: '5px 20px' }}
                onClick={() => {
                  setSelectedPaymentMethodId(
                    boosterLoanDetails?.loanDetail?.payment_method_id || null
                  );
                  setPayDialogOpen(true);
                }}
                disabled={boosterLoanDetails?.remaining_installment <= 0}
              >
                Pay Remaining
              </Button>
            )}

            {/* Pay Remaining Dialog */}
            <BoosterLoanPaymentDialog
              open={payDialogOpen}
              onClose={() => setPayDialogOpen(false)}
              boosterLoanDetails={boosterLoanDetails}
              paymentMethods={paymentMethods}
              selectedPaymentMethodId={selectedPaymentMethodId}
              onPaymentMethodChange={(methodId) => setSelectedPaymentMethodId(methodId)}
              onPaymentSuccess={(message, installmentIds, installmentNos) => {
                setShowPopup(false);
                startPaymentStatusPolling(installmentIds, installmentNos, message);
              }}
              onPaymentError={(message) => {
                setHeading('Error');
                setSuccess(false);
                setMsg(message);
                setShowPopup(true);
              }}
              onRefresh={getBoosterInstallments}
              setShowPaymentMethodDialog={setShowPaymentMethodDialog}
            />
          </Box>

          {/* Payment Schedule */}
          <Box className="text-white" sx={{ mt: "30px" }}>
            <List>
              {boosterLoanDetails?.installments?.map((installment, index) => {
                const { icon, label } = getPaymentDisplayDetails(
                  installment?.payment_method_id,
                  paymentMethods,
                  28
                );

                const selectedMethod28 = getPaymentDisplayDetails(
                  boosterLoanDetails?.loanDetail?.payment_method_id,
                  paymentMethods,
                  28
                );

                const statusKey = installment.status?.toUpperCase();
                const statusConfig = STATUS_CONFIG[statusKey] ?? {
                  label: "N/A",
                  color: "white",
                };

                return (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    sx={{
                      paddingBottom: 0,
                      paddingTop: 0,
                      gap: "16px",
                      width: "100%",
                    }}
                  >
                    {/* Icon & Timeline Column - Fixed Width */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      sx={{ flex: "0 0 50px" }}
                    >
                      {(() => {
                        // Render different icon styles depending on status
                        switch (statusKey) {
                          case 'PAID':
                            return <CheckCircleIcon color="success" />;
                          case 'OVERDUE':
                            return (
                              <Avatar sx={{ bgcolor: '#FF0000', width: 28, height: 28 }}>
                                <InfoOutlinedIcon sx={{ color: '#FFFFFF', fontSize: 18 }} />
                              </Avatar>
                            );
                          case 'RETRY':
                            return (
                              <Avatar sx={{ bgcolor: '#4A7AF2', width: 28, height: 28 }}>
                                <ReplayIcon sx={{ color: '#FFFFFF', fontSize: 18 }} />
                              </Avatar>
                            );
                          case 'FAILED':
                            return (
                              <Avatar sx={{ bgcolor: '#FF0000', width: 28, height: 28 }}>
                                <ErrorOutlineIcon sx={{ color: '#FFFFFF', fontSize: 18 }} />
                              </Avatar>
                            );
                          default:
                            return <RadioButtonUncheckedIcon />;
                        }
                      })()}
                      <Box sx={{ width: '3px', backgroundColor: '#666', height: '25px', my: '4px' }} />
                    </Box>

                    {/* Date Column - Fixed Width */}
                    <Box sx={{ flex: "0 0 150px" }}>
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "700",
                          fontSize: "14px",
                          display: "block",
                          color: "white",
                        }}
                      >
                        {formatTimestampToUserTimezone(+installment.due_date).date}
                      </Typography>
                    </Box>

                    {/* Status Column - Fixed Width */}
                    <Box
                      display="flex"
                      alignItems="center"
                      gap="5px"
                      sx={{ flex: "0 0 200px", justifyContent: "flex-start" }}
                    >
                      <Typography variant="caption" sx={{ fontSize: "12px", color: "white" }}>
                        {installment.installment_no} of {boosterLoanDetails?.installments.length}
                      </Typography>
                      <Typography variant="caption" sx={{ fontSize: "12px", color: "white" }}>
                        |
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: statusConfig.color,
                          fontSize: "12px",
                        }}
                      >
                        {statusConfig.label}
                      </Typography>
                    </Box>

                    {/* Payment Method Column - Flexible */}
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-start"
                      gap={1}
                      sx={{ flex: "1 1 auto", minWidth: "150px" }}
                    >
                      {installment?.payment_method_id ? icon : selectedMethodDetails.icon}
                      <Typography
                        style={{
                          color: "white",
                          fontSize: '14px',
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {installment?.payment_method_id ? label : selectedMethodDetails.label}
                      </Typography>
                    </Box>

                    {/* Amount Column - Fixed Width */}
                    <Box sx={{ flex: "0 0 100px", display: "flex", justifyContent: "flex-end" }}>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          color: "white",
                          fontWeight: "600",
                        }}
                      >
                        {formatter.balance(installment.amount).display}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </List>
          </Box>
        </Grid>

        {/* Loan Details */}
        <Grid item xs={12} md={4} mb={4}>
          <Typography variant="h6" className="text-white" gutterBottom>
            Loan Details
          </Typography>
          <Card className="w-100" sx={{ boxShadow: 'none', borderRadius: '30px', border: '1px solid #FFFFFF33', bgcolor: '#FFFFFF1A' }}>
            <CardContent sx={{ padding: '0px 0px !important' }} className="text-white">
              <Box display='flex' sx={{ padding: '20px 30px' }} alignItems='center' justifyContent='space-between'>
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar
                    src={cryptoDetails?.logo ? cryptoDetails?.logo : getLogoUrl(cryptoDetails?.symbol)}
                    alt={cryptoDetails?.symbol || stock}
                    sx={{ width: 36, height: 36 }}
                  />
                  <Box>
                    <Typography variant="subtitle1" mb={0}>{cryptoDetails?.name || boosterLoanDetails?.loanDetail?.name}</Typography>
                    <Typography variant="overline" className="text-secondary">
                      {cryptoDetails?.symbol || boosterLoanDetails?.loanDetail?.symbol}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {quote ? (
                    (() => {
                      const price = quote.price;
                      const percentChange = quote.percent_change_24h;
                      const { changeAmount, changePercentage } = calculateCryptoChange(price, percentChange);
                      const isPositive = changeAmount >= 0;
                      return (
                        <>
                          <Typography variant="subtitle1" mb={0}>
                            {formatter.price(price).display} {' '}
                            <span style={{ color: isPositive ? "#4EDF6D" : "#F2674A" }}>
                              {`${formatter.display(changeAmount, { showSign: true })} (${formatPercentage(changePercentage, { showSign: true })})`}
                            </span>
                          </Typography>
                          <Typography variant="caption">
                            {(() => {
                              const { date, time } = formatTimestampToUserTimezone(
                                quote?.last_updated
                              );
                              return <>{date} | <span className="text-blue">{time}</span></>;
                            })()}
                          </Typography>
                        </>
                      );
                    })()
                  ) : (
                    <>
                      <Typography variant="subtitle1" mb={0}>$-- <span style={{ color: "#4EDF6D" }}>--</span></Typography>
                      <Typography variant="caption" sx={{ color: '#4A7AF2' }}>--</Typography>
                    </>
                  )}
                </Box>
              </Box>
              {boosterLoanDetails?.loanDetail?.status?.toUpperCase() !== 'PAID' && (
                <>
                  <Divider sx={{ bgcolor: 'white' }}></Divider>
                  <Box padding='20px 30px' display='flex' justifyContent='space-between' alignItems='center'>
                    <Box>
                      <Typography variant="caption" className="text-secondary">Payment Method</Typography>
                      <Box display="flex" alignItems="center" justifyContent="center" gap={1} style={{ marginTop: '10px' }}>
                        {selectedMethodDetails.icon}
                        <Typography style={{ color: "white", fontSize: '14px' }}>{selectedMethodDetails.label}</Typography>
                      </Box>
                    </Box>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      sx={{ borderRadius: '20px', bgcolor: '#4A7AF2 !important', textTransform: 'none', padding: '5px 20px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenPopup(boosterLoanDetails?.loanDetail);
                      }}
                    >
                      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.3335 1.83398H6.00016C2.66683 1.83398 1.3335 3.16732 1.3335 6.50065V10.5007C1.3335 13.834 2.66683 15.1673 6.00016 15.1673H10.0002C13.3335 15.1673 14.6668 13.834 14.6668 10.5007V9.16732" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.6933 2.5135L5.43992 7.76683C5.23992 7.96683 5.03992 8.36017 4.99992 8.64683L4.71325 10.6535C4.60659 11.3802 5.11992 11.8868 5.84659 11.7868L7.85325 11.5002C8.13325 11.4602 8.52659 11.2602 8.73325 11.0602L13.9866 5.80683C14.8933 4.90017 15.3199 3.84684 13.9866 2.5135C12.6533 1.18017 11.5999 1.60684 10.6933 2.5135Z" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.93994 3.26758C10.3866 4.86091 11.6333 6.10758 13.2333 6.56091" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span style={{ marginLeft: '5px' }}>Change Method</span>
                    </Button>
                  </Box>
                </>
              )}
              <Divider sx={{ bgcolor: 'white' }}></Divider>
              <Box sx={{ padding: '20px 30px' }}>
                <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                  Loan Amount: <span className="text-white">{formatter.balance(boosterLoanDetails?.loanDetail?.loan_amount).display}</span>
                </Typography>
                <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                  Qty: <span className="text-white">{formatter.quantity(boosterLoanDetails?.loanDetail?.total_quantity).display}</span>
                </Typography>
                <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                  {boosterLoanDetails?.loanDetail?.status?.toUpperCase() === 'PAID' ? 'Transferred Qty' : 'Remaining Qty'}: <span className="text-white">{formatter.quantity(boosterLoanDetails?.loanDetail?.remaining_stock_quantity).display || '0.000000'}</span>
                </Typography>
                {(() => {
                  const percentage = boosterLoanDetails?.loanDetail?.origination_fee_percentage_amount;
                  const dollar = boosterLoanDetails?.loanDetail?.origination_fee_dollar;

                  const fee = Number(percentage) > 0 ? percentage : dollar;

                  if (Number(fee) <= 0) return null;

                  return (
                    <Typography
                      className="text-secondary"
                      variant="body2"
                      display="flex"
                      justifyContent="space-between"
                      gutterBottom
                    >
                      Origination Fee: <span className="text-white">{formatter.balance(fee).display}</span>
                    </Typography>
                  );
                })()}

                {(() => {
                  const percentage = boosterLoanDetails?.loanDetail?.prepayment_fee_percentage_amount;
                  const dollar = boosterLoanDetails?.loanDetail?.prepayment_fee_dollar;

                  const prepaymentFee = Number(percentage) > 0 ? percentage : dollar;

                  if (
                    boosterLoanDetails?.loanDetail?.status?.toUpperCase() !== 'PAID' ||
                    Number(prepaymentFee) <= 0
                  ) {
                    return null;
                  }

                  return (
                    <Typography
                      className="text-secondary"
                      variant="body2"
                      display="flex"
                      justifyContent="space-between"
                      gutterBottom
                    >
                      Prepayment Fee:{' '}
                      <span className="text-white">{formatter.balance(prepaymentFee).display}</span>
                    </Typography>
                  );
                })()}

                {boosterLoanDetails?.loanDetail?.interest > 0 ? (
                  <>
                    <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                      Interest: <span className="text-white">{boosterLoanDetails?.loanDetail?.interest}%</span>
                    </Typography>
                    <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                      {boosterLoanDetails?.loanDetail?.status?.toUpperCase() === 'PAID' ? 'Total paid interest' : 'Interest Amount'}: <span className="text-white">{boosterLoanDetails?.loanDetail?.status?.toUpperCase() === 'PAID' ? `${formatter.balance(boosterLoanDetails?.loanDetail?.total_paid_interest).display}` : `${formatter.balance(boosterLoanDetails?.loanDetail?.interest_amount).display}`}</span>
                    </Typography>
                  </>
                ) : (
                  <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                    Service Fee: <span className="text-white">{formatter.balance(boosterLoanDetails?.loanDetail?.service_fee).display}</span>
                  </Typography>
                )}
                {/* <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                  Fees: <span className="text-white">${formatter.balance(boosterLoanDetails?.loanDetail?.fees)}</span>
                </Typography> */}
                <Typography className="text-secondary" variant="body2" display="flex" justifyContent="space-between" gutterBottom>
                  {
                    boosterLoanDetails?.loanDetail?.status?.toUpperCase() === 'PAID' ?
                      <>
                        Total Paid Amount: <span className="text-white">{formatter.balance(boosterLoanDetails?.loanDetail?.paid_amount).display}</span>
                      </>
                      :
                      <>
                        Total Amount: <span className="text-white">{formatter.balance(boosterLoanDetails?.loanDetail?.total_amount).display}</span>
                      </>
                  }
                </Typography>
              </Box>
            </CardContent>
          </Card>
          {/* Buy/Sell Component */}
          {cryptoDetails && memoizedStockDetail && (
            <Box sx={{ mt: 4 }} key={buySellRefreshKey}>
              <MemoizedBuySell
                stockDetail={memoizedStockDetail}
                tickerData={memoizedTickerData}
                tickerDataAll={cryptoDetails}
                icon={cryptoDetails?.logo}
                tradType="Buy"
                assetType="crypto"
              />
            </Box>
          )}

        </Grid>

      </Grid>



      {/* Payment Method Dialog (for both right card and pay remaining) */}
      <Dialog
        open={openPopup || showPaymentMethodDialog}
        onClose={() => {
          setOpenPopup(false);
          setShowPaymentMethodDialog(false);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className='text-white' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Change Payment Method
          <IconButton onClick={() => {
            setOpenPopup(false);
            setShowPaymentMethodDialog(false);
          }} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Repayment
            paymentMethods={paymentMethods}
            setSelectedPaymentMethod={(method: any) => {
              if (showPaymentMethodDialog) {
                if (method.id) {
                  setSelectedPaymentMethodId(method.id);
                  setShowPaymentMethodDialog(false);
                } else {
                  console.warn('Unable to resolve payment method identifier', method);
                }
              } else {
                handleChangeMethod(method);
                setOpenPopup(false);
              }
            }}
            fetchPaymentMethods={fetchAllPaymentMethods}
          />
        </DialogContent>
      </Dialog>
      {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}
    </Container>
  );
}

export default BoosterLoanDetails;